import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=55d56791"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports